<template>
  <main class="forbidden-page">
    <div class="forbidden-card">
      <div class="icon-wrap">
        <el-icon class="lock-icon"><Lock /></el-icon>
      </div>

      <div class="status-badge">403</div>
      <h1>无权访问</h1>
      <p class="description">
        当前账号没有访问该页面的权限，请返回工作台或使用具备权限的账号重新登录。
      </p>

      <div class="action-row">
        <el-button size="large" class="home-btn" @click="goHome">
          <el-icon><House /></el-icon>
          返回工作台
        </el-button>
        <el-button size="large" type="primary" class="relogin-btn" @click="handleRelogin">
          <el-icon><RefreshRight /></el-icon>
          重新登录
        </el-button>
      </div>

      <button class="logout-link" type="button" @click="handleLogout">
        <el-icon><SwitchButton /></el-icon>
        退出登录
      </button>
    </div>
  </main>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { House, Lock, RefreshRight, SwitchButton } from '@element-plus/icons-vue'
import { logout } from '@/api/auth'

export default {
  name: 'ForbiddenPage',
  components: { House, Lock, RefreshRight, SwitchButton },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const redirectTarget = computed(() => {
      const redirect = Array.isArray(route.query.redirect)
        ? route.query.redirect[0]
        : route.query.redirect

      if (
        typeof redirect === 'string' &&
        redirect &&
        !redirect.startsWith('/forbidden') &&
        !redirect.startsWith('/login')
      ) {
        return redirect
      }

      return '/videos'
    })

    const goHome = () => {
      router.push('/videos')
    }

    const handleRelogin = () => {
      logout()
      ElMessage.success('请重新登录')
      router.replace({
        path: '/login',
        query: { redirect: redirectTarget.value }
      })
    }

    const handleLogout = () => {
      logout()
      ElMessage.success('已退出登录')
      router.replace('/login')
    }

    return { goHome, handleRelogin, handleLogout }
  }
}
</script>

<style scoped>
.forbidden-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f0f4ff;
}

.forbidden-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(480px, calc(100% - 48px));
  padding: 48px 40px 40px;
  background: #ffffff;
  border: 1px solid #d0e0ff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(24, 117, 240, 0.08);
  text-align: center;
}

.icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  background: #ecf5ff;
  border-radius: 50%;
}

.lock-icon {
  font-size: 34px;
  color: #1875F0;
}

.status-badge {
  margin-bottom: 12px;
  padding: 2px 12px;
  font-size: 13px;
  font-weight: 700;
  color: #1875F0;
  background: #ecf5ff;
  border: 1px solid #d0e0ff;
  border-radius: 999px;
  letter-spacing: 0.04em;
}

h1 {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 700;
  color: #1A2B45;
}

.description {
  margin: 0 0 32px;
  font-size: 15px;
  line-height: 1.7;
  color: #606266;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  width: 100%;
}

.action-row :deep(.el-button) {
  flex: 1;
  min-width: 130px;
  height: 44px;
  border-radius: 8px;
  font-weight: 600;
  margin-left: 0;
}

.home-btn {
  color: #1A2B45;
  background: #f5f7fa;
  border-color: #d0e0ff;
}

.home-btn:hover {
  color: #1875F0;
  background: #ecf5ff;
  border-color: #1875F0;
}

.relogin-btn {
  background: #1875F0;
  border-color: #1875F0;
}

.relogin-btn:hover {
  background: #1565d4;
  border-color: #1565d4;
}

.logout-link {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  padding: 0;
  margin-top: 20px;
  font-size: 14px;
  color: #909399;
  cursor: pointer;
  background: transparent;
  border: 0;
  transition: color 0.2s;
}

.logout-link:hover {
  color: #f56c6c;
}
</style>
